import { SxProps, Theme } from "@mui/material";

export const COMMON_GRID_HEADER_STYLE: SxProps<Theme> = {
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#F4F7FE !important",
    minHeight: "48px !important",
  },
  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "#F4F7FE !important",
    borderRight: "1px solid #E0E0E0",
    borderBottom: "1px solid #E0E0E0",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontFamily: "Poppins, sans-serif !important",
    fontWeight: "700 !important",
    fontSize: "12px !important",
    lineHeight: "24px !important",
    letterSpacing: "0.17px !important",
    color: "#000000 !important",
    textAlign: "center",
    justifyContent: "center",
    display: "flex",
    width: "100%",
  },
  "& .MuiDataGrid-cell": {
    borderRight: "1px solid #E0E0E0",
    borderBottom: "1px solid #E0E0E0",
  },
};

export const DIALOG_PAPER_PROPS = {
  sx: {
    width: "100%",
    maxWidth: { xs: "100%", sm: "80%", md: "60%", lg: "40%" },
    borderRadius: "8px",
    boxShadow: 3,
  },
};

export const ACTION_DIALOG_PAPER_PROPS = {
  sx: {
    width: "100%",
    maxWidth: { xs: "45%", sm: "70%", md: "25%", lg: "20%" },
    boxShadow: 3,
  },
};
